export const STATUS_LOOKUP = {
  accepted: {
    class: "insurance-eligibility-status-card--accepted",
    definition: "Patient is eligible for services",
    formattedStatus: "Accepted",
  },
  declined: {
    class: "insurance-eligibility-status-card--declined",
    definition: "Patient is not eligible for services",
    formattedStatus: "Declined",
  },
  no_match: {
    class: "insurance-eligibility-status-card--no-match",
    definition: "Patient's information was not found",
    formattedStatus: "No Match",
  },
  not_configured: {
    class: "insurance-eligibility-status-card--not-configured",
    definition: "Patient's carrier is not configured with eligibility check",
    formattedStatus: "Not Configured",
  },
  pending: {
    class: "insurance-eligibility-status-card--pending",
    definition: "Unable to check eligibility at this time",
    formattedStatus: "Pending",
  },
};
